import React, { FC, PropsWithChildren } from 'react';
import { Table, TableProps } from 'react-bootstrap';
import './styles.scss';
import cn from 'classnames';

// Отдельная обертка для таблиц в виджетах. В таких таблицах отсутствуют внешние отступы
export const WidgetTable: FC<PropsWithChildren<TableProps>> = ({ children, className, ...props }) => (
  <Table className={cn(className, 'widget-table')} {...props}>
    {children}
  </Table>
);
